import React, { useState } from "react";
import { BRAND_COLOR } from "../../common/constants";

const faqsData = [
  {
    question: "What is Speak Bold with KK?",
    answer:
      "Speak Bold with KK is an online learning platform focused on improving spoken English, confidence, and communication skills. We provide live interactive sessions, group discussions, and guided practice led by experienced speakers. Our goal is to help you speak confidently in real-life and professional situations.",
  },
  {
    question: "Who can join these sessions?",
    answer:
      "Anyone who wants to improve their communication skills can join Speak Bold with KK. Our sessions are suitable for students, working professionals, job seekers, and beginners who want to gain confidence while speaking English. No prior experience is required.",
  },
  {
    question: "What types of sessions are available?",
    answer:
      "We offer Group Sessions, Group Discussions, and 1-to-1 personalized sessions. Each session type is designed to address different learning needs, from collaborative discussions to focused individual practice. Availability depends on your selected subscription plan.",
  },
  {
    question: "How do I book a live session?",
    answer:
      "After logging in, you can browse available sessions on the website. Select a session that fits your schedule and click the Book button to confirm your spot. Once booked, the session details will be visible in your dashboard.",
  },
  {
    question: "How will I join a live session?",
    answer:
      "All live sessions are conducted via Zoom for smooth and interactive communication. When the session time approaches, a Join button will appear on your session card. Clicking it will open the Zoom meeting link in a new tab.",
  },
  {
    question: "When will the Zoom link be available?",
    answer:
      "The Zoom link is generally made available shortly before the session begins. This ensures security and smooth session management. If the link is not visible yet, please check again closer to the session start time.",
  },
  {
    question: "What if I miss a session?",
    answer:
      "If you miss a scheduled session, it will be marked as expired. Currently, missed sessions cannot be rescheduled or refunded. We recommend joining sessions on time to get the maximum benefit.",
  },
  {
    question: "Can I cancel a booked session?",
    answer:
      "Yes, you can cancel a booked session before it starts, subject to our cancellation policy. The option to cancel will be available in your dashboard. Please cancel early so the slot can be made available to others.",
  },
  {
    question: "Do you offer refunds?",
    answer:
      "Refunds are processed according to our Cancellation & Refund Policy. Eligibility depends on factors such as session type and cancellation timing. For complete details, please refer to the Refund Policy page on our website.",
  },
  {
    question: "How can I contact support?",
    answer:
      "You can contact our support team through the Contact Us page or by emailing us at support@speakboldwithkk.com. We aim to respond to all queries as quickly as possible. Your feedback and questions are always welcome.",
  },
];

const Faqs = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div
      style={{
        maxWidth: 900,
        margin: "60px auto",
        padding: "0 20px",
      }}
    >
      {/* ===== PAGE HEADER ===== */}
      <h1
        style={{
          textAlign: "center",
          marginBottom: 10,
          color: BRAND_COLOR,
        }}
      >
        Frequently Asked Questions
      </h1>

      <p
        style={{
          textAlign: "center",
          marginBottom: 40,
          fontSize: 16,
          color: "#555",
        }}
      >
        Find answers to common questions about Speak Bold with KK.
      </p>

      {/* ===== FAQ LIST ===== */}
      {faqsData.map((faq, index) => (
        <div
          key={index}
          style={{
            border: "1px solid #ddd",
            borderRadius: 8,
            marginBottom: 15,
            overflow: "hidden",
          }}
        >
          {/* Question */}
          <div
            onClick={() => toggleFAQ(index)}
            style={{
              padding: "15px 18px",
              cursor: "pointer",
              backgroundColor:
                activeIndex === index ? "#f0f4ff" : "#fafafa",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              fontWeight: 600,
            }}
          >
            <span>{faq.question}</span>
            <span style={{ fontSize: 18 }}>
              {activeIndex === index ? "−" : "+"}
            </span>
          </div>

          {/* Answer */}
          {activeIndex === index && (
            <div
              style={{
                padding: "15px 18px",
                backgroundColor: "#fff",
                fontSize: 15,
                lineHeight: 1.6,
                color: "#444",
              }}
            >
              {faq.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Faqs;
